import {ChartDataset} from "chart.js";

export const prizes: ChartDataset<'bar'>[] = [
    {
        label: "2010",
        data: [0,1,0,0,0,0,0],
        backgroundColor: 'rgba(50, 187, 141, 1)'
    },
    {
        label: "2011",
        data: [0,1,0,0,0,0,0],
        backgroundColor: 'rgba(124, 210, 178)'
    },
    {
        label: "2012",
        data: [0,1,0,0,0,0,0],
        backgroundColor: 'rgba(179, 228, 205, 1)'
    },
    {
        label: "2013",
        data: [0,1,0,1,0,1,1],
        backgroundColor: 'rgba(211, 237, 221, 1)'
    },
    {
        label: "2014",
        data: [0,1,0,0,0,0,0],
        backgroundColor: 'rgba(167, 98, 125, 1)'
    },
    {
        label: "2015",
        data: [0,1,4,3,0,1,1],
        backgroundColor: 'rgba(198, 154, 168, 1)'
    },
    {
        label: "2016",
        data: [0,1,1,0,0,0],
        backgroundColor: 'rgba(222, 202, 204, 1)'
    },
    {
        label: "2017",
        data: [0,1,4,1,0,1],
        backgroundColor:     'rgba(235, 225, 222, 1)'
    },
    {
        label: "2018",
        data: [0,1,0,0,0,0],
        backgroundColor: 'rgba(50, 187, 141, 1)'
    },
    {
        label: "2019",
        data: [0,1,3,1,0,0],
        backgroundColor: 'rgba(124, 210, 178, 1)'
    },
    {
        label: "2020",
        data: [0,1,0,0,0,0],
        backgroundColor: 'rgba(179, 228, 205, 1)'
    },
    {
        label: "2021",
        data: [0,1,2,0,1,0],
        backgroundColor: 'rgba(211, 237, 221, 1)'
    },
    {
        label: "2023",
        data: [0,1,0,0,0,0],
        backgroundColor: 'rgba(167, 98, 125, 1)'
    },
    {
        label: "2024",
        data: [0,1,0,3,0,0],
        backgroundColor: 'rgba(198, 154, 168, 1)'
    },
    {
        label: "2025",
        data: [1,0,0,0,0,0],
        backgroundColor: 'rgba(222, 202, 204, 1)'
    }/*,
    {
        label: "2025",
        data: [1],
        backgroundColor:     'rgba(235, 225, 222, 1)'
    }*/
]

export const prize_labels= ["Silver Medal", "Gold Medal", "Nominations", "Special Prizes","Top Ten","Best Village Project", "Runner-Up"]